<template>
  <main class="main-content" v-if="hasActiveProduct">
    <ProjectNavbar
      v-if="dealerMode"
      :hideEditButton="true"
      @openShareProjectModal="toggleShareProjectModal"
    />
    <DealerHeader @openDealerLoginModal="openDealerLoginModal" />

    <transition name="fade">
      <ShareProjectModal
        v-if="showShareProjectModal"
        :isModalOpen="showShareProjectModal"
        @close="toggleShareProjectModal"
    /></transition>

    <ActiveProduct />
    <!-- Dealer Login -->
    <transition name="fade">
      <DealerLoginModal
        v-if="showDealerLoginModal"
        @close="closeDealerLoginModal"
    /></transition>
  </main>
</template>

<script>
import ActiveProduct from "@/components/Projects/Project/ActiveProduct/ActiveProduct.vue";
import DealerHeader from "@/components/Projects/Project/DealerHeader";
import DealerLoginModal from "@/components/Projects/Project/DealerLoginModal";
import ProjectNavbar from "@/components/Projects/Project/ProjectNavbar";
import ShareProjectModal from "@/components/Projects/Project/ShareProjectModal.vue";

import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "ActiveProductPage",
  components: {
    ActiveProduct,
    DealerHeader,
    DealerLoginModal,
    ProjectNavbar,
    ShareProjectModal,
  },
  data() {
    return {
      showDealerLoginModal: false,
      showShareProjectModal: false,
    };
  },

  computed: {
    ...mapState("auth", ["dealerMode"]),
    ...mapState("project", ["activeProduct"]),
    ...mapGetters("project", ["isPlaybook", "isShowroom"]),
    ...mapState("threekit", ["decorations3DList"]),
    hasActiveProduct() {
      return this.activeProduct?.id;
    },
  },

  methods: {
    ...mapActions("project", ["initProject", "redirectToShowroomHome"]),
    ...mapActions("threekit", ["getColorsByMaterial"]),

    closeDealerLoginModal() {
      this.showDealerLoginModal = false;
    },

    openDealerLoginModal() {
      this.showDealerLoginModal = true;
    },

    toggleShareProjectModal() {
      this.showShareProjectModal = !this.showShareProjectModal;
    },
  },

  async mounted() {
    if (this.isShowroom) {
      if (!this.hasActiveProduct) {
        this.redirectToShowroomHome();
      }
      //todo check playbooks req field
    }
    await this.getColorsByMaterial();
    await this.initProject();
  },
};
</script>

<style lang="scss" scoped>
nav {
  height: 4rem;
}
#dealer-header {
  height: 3rem;
  padding-bottom: 0;
}
</style>
